module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_mobile_e0b941548f56c55b5446d1c5cbb4a40a.webp";